import { useContext } from "react";

import { FirebaseMessagingContext } from "../contexts/FirebaseMessagingContext";

export const useFirebaseMessaging = () => {
  return useContext(FirebaseMessagingContext);
};